import { render } from "./AISymptomCheck.vue?vue&type=template&id=40b28a70&scoped=true"
import script from "./AISymptomCheck.vue?vue&type=script&lang=js"
export * from "./AISymptomCheck.vue?vue&type=script&lang=js"

import "./AISymptomCheck.vue?vue&type=style&index=0&id=40b28a70&lang=css"
import "./AISymptomCheck.vue?vue&type=style&index=1&id=40b28a70&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b28a70"]])

export default __exports__